/**
 * gtagUtils.js
 * Utilidad oficial para Google Ads Tag (gtag.js) AW-18386242156
 * Permite medir conversiones, eventos de agendamiento y vistas de página en React SPA.
 */

export const GOOGLE_TAG_ID = 'AW-18386242156';

/**
 * Registra una vista de página en Google Ads / Google Analytics
 * @param {string} path - Ruta relativa de la página (ej: /canchas, /reserva)
 */
export const trackPageView = (path) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('config', GOOGLE_TAG_ID, {
      page_path: path,
    });
  }
};

/**
 * Registra un evento de conversión de Google Ads o interacción de usuario
 * @param {string} action - Nombre de la acción (ej: 'conversion', 'booking_complete', 'registration')
 * @param {Object} params - Parámetros adicionales (monto, ID de turno, etc.)
 */
export const trackGoogleEvent = (action, params = {}) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', action, {
      send_to: GOOGLE_TAG_ID,
      ...params,
    });
  }
};
